// @generated by protoc-gen-es v2.12.0 with parameter "target=ts"
// @generated from file Messages/Validation.proto (package time_tracking.messages.validation, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { Duration } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_duration, file_google_protobuf_wrappers } from "@bufbuild/protobuf/wkt";
import { file_Options_FieldOptions } from "../Options/FieldOptions_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file Messages/Validation.proto.
 */
export const file_Messages_Validation: GenFile = /*@__PURE__*/
  fileDesc("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", [file_google_protobuf_duration, file_google_protobuf_wrappers, file_Options_FieldOptions]);

/**
 * Represents a FluentValidation error.
 *
 * @generated from message time_tracking.messages.validation.ValidationErrorDto
 */
export type ValidationErrorDto = Message<"time_tracking.messages.validation.ValidationErrorDto"> & {
  /**
   * The custom string error code of the validation error if one has been provided.
   *
   * @generated from field: google.protobuf.StringValue error_code = 1;
   */
  errorCode?: string | undefined;

  /**
   * A human readable error message.
   *
   * @generated from field: string error_message = 2;
   */
  errorMessage: string;

  /**
   * The name of the property that has failed the validation.
   *
   * @generated from field: string property_name = 3;
   */
  propertyName: string;
};

/**
 * Describes the message time_tracking.messages.validation.ValidationErrorDto.
 * Use `create(ValidationErrorDtoSchema)` to create a new message.
 */
export const ValidationErrorDtoSchema: GenMessage<ValidationErrorDto> = /*@__PURE__*/
  messageDesc(file_Messages_Validation, 0);

/**
 * Provides a minimum length validator for strings.
 *
 * @generated from message time_tracking.messages.validation.MinimumLengthValidationDto
 */
export type MinimumLengthValidationDto = Message<"time_tracking.messages.validation.MinimumLengthValidationDto"> & {
  /**
   * The configured minimum length.
   *
   * @generated from field: int32 value = 1;
   */
  value: number;

  /**
   * Optional message template. See for details:
   * https://docs.fluentvalidation.net/en/latest/built-in-validators.html#minlength-validator
   *
   * @generated from field: google.protobuf.StringValue message_template = 2;
   */
  messageTemplate?: string | undefined;

  /**
   * Whether to disable this validator during development.
   *
   * @generated from field: bool disable_in_development = 3;
   */
  disableInDevelopment: boolean;

  /**
   * A custom string error code that will be returned as part of the validation error.
   *
   * @generated from field: google.protobuf.StringValue error_code = 4;
   */
  errorCode?: string | undefined;
};

/**
 * Describes the message time_tracking.messages.validation.MinimumLengthValidationDto.
 * Use `create(MinimumLengthValidationDtoSchema)` to create a new message.
 */
export const MinimumLengthValidationDtoSchema: GenMessage<MinimumLengthValidationDto> = /*@__PURE__*/
  messageDesc(file_Messages_Validation, 1);

/**
 * Provides a maximum length validator for strings.
 *
 * @generated from message time_tracking.messages.validation.MaximumLengthValidationDto
 */
export type MaximumLengthValidationDto = Message<"time_tracking.messages.validation.MaximumLengthValidationDto"> & {
  /**
   * The configured maximum length.
   *
   * @generated from field: int32 value = 1;
   */
  value: number;

  /**
   * Optional message template. See for details:
   * https://docs.fluentvalidation.net/en/latest/built-in-validators.html#maxlength-validator
   *
   * @generated from field: google.protobuf.StringValue message_template = 2;
   */
  messageTemplate?: string | undefined;

  /**
   * Whether to disable this validator during development.
   *
   * @generated from field: bool disable_in_development = 3;
   */
  disableInDevelopment: boolean;

  /**
   * A custom string error code that will be returned as part of the validation error.
   *
   * @generated from field: google.protobuf.StringValue error_code = 4;
   */
  errorCode?: string | undefined;
};

/**
 * Describes the message time_tracking.messages.validation.MaximumLengthValidationDto.
 * Use `create(MaximumLengthValidationDtoSchema)` to create a new message.
 */
export const MaximumLengthValidationDtoSchema: GenMessage<MaximumLengthValidationDto> = /*@__PURE__*/
  messageDesc(file_Messages_Validation, 2);

/**
 * Provides a email address validator for strings.
 *
 * @generated from message time_tracking.messages.validation.EmailAddressValidationDto
 */
export type EmailAddressValidationDto = Message<"time_tracking.messages.validation.EmailAddressValidationDto"> & {
  /**
   * Optional message template. See for details:
   * https://docs.fluentvalidation.net/en/latest/built-in-validators.html#email-validator
   *
   * @generated from field: google.protobuf.StringValue message_template = 1;
   */
  messageTemplate?: string | undefined;

  /**
   * Whether to disable this validator during development.
   *
   * @generated from field: bool disable_in_development = 2;
   */
  disableInDevelopment: boolean;

  /**
   * A custom string error code that will be returned as part of the validation error.
   *
   * @generated from field: google.protobuf.StringValue error_code = 3;
   */
  errorCode?: string | undefined;
};

/**
 * Describes the message time_tracking.messages.validation.EmailAddressValidationDto.
 * Use `create(EmailAddressValidationDtoSchema)` to create a new message.
 */
export const EmailAddressValidationDtoSchema: GenMessage<EmailAddressValidationDto> = /*@__PURE__*/
  messageDesc(file_Messages_Validation, 3);

/**
 * Provides a string, number and collection validator that only accepts empty values.
 *
 * @generated from message time_tracking.messages.validation.EmptyValidationDto
 */
export type EmptyValidationDto = Message<"time_tracking.messages.validation.EmptyValidationDto"> & {
  /**
   * Optional message template. See for details:
   * https://docs.fluentvalidation.net/en/latest/built-in-validators.html#empty-validator
   *
   * @generated from field: google.protobuf.StringValue message_template = 1;
   */
  messageTemplate?: string | undefined;

  /**
   * Whether to disable this validator during development.
   *
   * @generated from field: bool disable_in_development = 2;
   */
  disableInDevelopment: boolean;

  /**
   * A custom string error code that will be returned as part of the validation error.
   *
   * @generated from field: google.protobuf.StringValue error_code = 3;
   */
  errorCode?: string | undefined;
};

/**
 * Describes the message time_tracking.messages.validation.EmptyValidationDto.
 * Use `create(EmptyValidationDtoSchema)` to create a new message.
 */
export const EmptyValidationDtoSchema: GenMessage<EmptyValidationDto> = /*@__PURE__*/
  messageDesc(file_Messages_Validation, 4);

/**
 * Provides a string, number and collection validator that disallows empty values.
 *
 * @generated from message time_tracking.messages.validation.NotEmptyValidationDto
 */
export type NotEmptyValidationDto = Message<"time_tracking.messages.validation.NotEmptyValidationDto"> & {
  /**
   * Optional message template. See for details:
   * https://docs.fluentvalidation.net/en/latest/built-in-validators.html#notempty-validator
   *
   * @generated from field: google.protobuf.StringValue message_template = 1;
   */
  messageTemplate?: string | undefined;

  /**
   * Whether to disable this validator during development.
   *
   * @generated from field: bool disable_in_development = 2;
   */
  disableInDevelopment: boolean;

  /**
   * A custom string error code that will be returned as part of the validation error.
   *
   * @generated from field: google.protobuf.StringValue error_code = 3;
   */
  errorCode?: string | undefined;
};

/**
 * Describes the message time_tracking.messages.validation.NotEmptyValidationDto.
 * Use `create(NotEmptyValidationDtoSchema)` to create a new message.
 */
export const NotEmptyValidationDtoSchema: GenMessage<NotEmptyValidationDto> = /*@__PURE__*/
  messageDesc(file_Messages_Validation, 5);

/**
 * Provides a regular expression validator for strings.
 *
 * @generated from message time_tracking.messages.validation.RegularExpressionValidationDto
 */
export type RegularExpressionValidationDto = Message<"time_tracking.messages.validation.RegularExpressionValidationDto"> & {
  /**
   * The regular expression to execute against the value of the field.
   *
   * @generated from field: string value = 1;
   */
  value: string;

  /**
   * Optional message template. See for details:
   * https://docs.fluentvalidation.net/en/latest/built-in-validators.html#regular-expression-validator
   *
   * @generated from field: google.protobuf.StringValue message_template = 2;
   */
  messageTemplate?: string | undefined;

  /**
   * Whether to disable this validator during development.
   *
   * @generated from field: bool disable_in_development = 3;
   */
  disableInDevelopment: boolean;

  /**
   * A custom string error code that will be returned as part of the validation error.
   *
   * @generated from field: google.protobuf.StringValue error_code = 4;
   */
  errorCode?: string | undefined;
};

/**
 * Describes the message time_tracking.messages.validation.RegularExpressionValidationDto.
 * Use `create(RegularExpressionValidationDtoSchema)` to create a new message.
 */
export const RegularExpressionValidationDtoSchema: GenMessage<RegularExpressionValidationDto> = /*@__PURE__*/
  messageDesc(file_Messages_Validation, 6);

/**
 * Provides an exclusive upper bound validator for numbers.
 *
 * @generated from message time_tracking.messages.validation.LessThanValidationDto
 */
export type LessThanValidationDto = Message<"time_tracking.messages.validation.LessThanValidationDto"> & {
  /**
   * The configured exclusive upper bound.
   *
   * @generated from field: int32 value = 1;
   */
  value: number;

  /**
   * Optional message template. See for details:
   * https://docs.fluentvalidation.net/en/latest/built-in-validators.html#less-than-validator
   *
   * @generated from field: google.protobuf.StringValue message_template = 2;
   */
  messageTemplate?: string | undefined;

  /**
   * Whether to disable this validator during development.
   *
   * @generated from field: bool disable_in_development = 3;
   */
  disableInDevelopment: boolean;

  /**
   * A custom string error code that will be returned as part of the validation error.
   *
   * @generated from field: google.protobuf.StringValue error_code = 4;
   */
  errorCode?: string | undefined;
};

/**
 * Describes the message time_tracking.messages.validation.LessThanValidationDto.
 * Use `create(LessThanValidationDtoSchema)` to create a new message.
 */
export const LessThanValidationDtoSchema: GenMessage<LessThanValidationDto> = /*@__PURE__*/
  messageDesc(file_Messages_Validation, 7);

/**
 * Provides an inclusive upper bound validator for numbers.
 *
 * @generated from message time_tracking.messages.validation.LessThanOrEqualToValidationDto
 */
export type LessThanOrEqualToValidationDto = Message<"time_tracking.messages.validation.LessThanOrEqualToValidationDto"> & {
  /**
   * The configured inclusive uppper bound.
   *
   * @generated from field: int32 value = 1;
   */
  value: number;

  /**
   * Optional message template. See for details:
   * https://docs.fluentvalidation.net/en/latest/built-in-validators.html#less-than-or-equal-validator
   *
   * @generated from field: google.protobuf.StringValue message_template = 2;
   */
  messageTemplate?: string | undefined;

  /**
   * Whether to disable this validator during development.
   *
   * @generated from field: bool disable_in_development = 3;
   */
  disableInDevelopment: boolean;

  /**
   * A custom string error code that will be returned as part of the validation error.
   *
   * @generated from field: google.protobuf.StringValue error_code = 4;
   */
  errorCode?: string | undefined;
};

/**
 * Describes the message time_tracking.messages.validation.LessThanOrEqualToValidationDto.
 * Use `create(LessThanOrEqualToValidationDtoSchema)` to create a new message.
 */
export const LessThanOrEqualToValidationDtoSchema: GenMessage<LessThanOrEqualToValidationDto> = /*@__PURE__*/
  messageDesc(file_Messages_Validation, 8);

/**
 * Provides an exclusive lower bound validator for numbers.
 *
 * @generated from message time_tracking.messages.validation.GreaterThanValidationDto
 */
export type GreaterThanValidationDto = Message<"time_tracking.messages.validation.GreaterThanValidationDto"> & {
  /**
   * The configured exclusive lower bound.
   *
   * @generated from field: int32 value = 1;
   */
  value: number;

  /**
   * Optional message template. See for details:
   * https://docs.fluentvalidation.net/en/latest/built-in-validators.html#greater-than-validator
   *
   * @generated from field: google.protobuf.StringValue message_template = 2;
   */
  messageTemplate?: string | undefined;

  /**
   * Whether to disable this validator during development.
   *
   * @generated from field: bool disable_in_development = 3;
   */
  disableInDevelopment: boolean;

  /**
   * A custom string error code that will be returned as part of the validation error.
   *
   * @generated from field: google.protobuf.StringValue error_code = 4;
   */
  errorCode?: string | undefined;
};

/**
 * Describes the message time_tracking.messages.validation.GreaterThanValidationDto.
 * Use `create(GreaterThanValidationDtoSchema)` to create a new message.
 */
export const GreaterThanValidationDtoSchema: GenMessage<GreaterThanValidationDto> = /*@__PURE__*/
  messageDesc(file_Messages_Validation, 9);

/**
 * Provides an inclusive lower bound validator for numbers.
 *
 * @generated from message time_tracking.messages.validation.GreaterThanOrEqualToValidationDto
 */
export type GreaterThanOrEqualToValidationDto = Message<"time_tracking.messages.validation.GreaterThanOrEqualToValidationDto"> & {
  /**
   * The configured inclusive lower bound.
   *
   * @generated from field: int32 value = 1;
   */
  value: number;

  /**
   * Optional message template. See for details:
   * https://docs.fluentvalidation.net/en/latest/built-in-validators.html#greater-than-or-equal-validator
   *
   * @generated from field: google.protobuf.StringValue message_template = 2;
   */
  messageTemplate?: string | undefined;

  /**
   * Whether to disable this validator during development.
   *
   * @generated from field: bool disable_in_development = 3;
   */
  disableInDevelopment: boolean;

  /**
   * A custom string error code that will be returned as part of the validation error.
   *
   * @generated from field: google.protobuf.StringValue error_code = 4;
   */
  errorCode?: string | undefined;
};

/**
 * Describes the message time_tracking.messages.validation.GreaterThanOrEqualToValidationDto.
 * Use `create(GreaterThanOrEqualToValidationDtoSchema)` to create a new message.
 */
export const GreaterThanOrEqualToValidationDtoSchema: GenMessage<GreaterThanOrEqualToValidationDto> = /*@__PURE__*/
  messageDesc(file_Messages_Validation, 10);

/**
 * Provides a null check validator.
 *
 * @generated from message time_tracking.messages.validation.NullValidationDto
 */
export type NullValidationDto = Message<"time_tracking.messages.validation.NullValidationDto"> & {
  /**
   * Optional message template. See for details:
   * https://docs.fluentvalidation.net/en/latest/built-in-validators.html#null-validator
   *
   * @generated from field: google.protobuf.StringValue message_template = 1;
   */
  messageTemplate?: string | undefined;

  /**
   * Whether to disable this validator during development.
   *
   * @generated from field: bool disable_in_development = 2;
   */
  disableInDevelopment: boolean;

  /**
   * A custom string error code that will be returned as part of the validation error.
   *
   * @generated from field: google.protobuf.StringValue error_code = 3;
   */
  errorCode?: string | undefined;
};

/**
 * Describes the message time_tracking.messages.validation.NullValidationDto.
 * Use `create(NullValidationDtoSchema)` to create a new message.
 */
export const NullValidationDtoSchema: GenMessage<NullValidationDto> = /*@__PURE__*/
  messageDesc(file_Messages_Validation, 11);

/**
 * Provides a not-null check validator.
 *
 * @generated from message time_tracking.messages.validation.NotNullValidationDto
 */
export type NotNullValidationDto = Message<"time_tracking.messages.validation.NotNullValidationDto"> & {
  /**
   * Optional message template. See for details:
   * https://docs.fluentvalidation.net/en/latest/built-in-validators.html#notnull-validator
   *
   * @generated from field: google.protobuf.StringValue message_template = 1;
   */
  messageTemplate?: string | undefined;

  /**
   * Whether to disable this validator during development.
   *
   * @generated from field: bool disable_in_development = 2;
   */
  disableInDevelopment: boolean;

  /**
   * A custom string error code that will be returned as part of the validation error.
   *
   * @generated from field: google.protobuf.StringValue error_code = 3;
   */
  errorCode?: string | undefined;
};

/**
 * Describes the message time_tracking.messages.validation.NotNullValidationDto.
 * Use `create(NotNullValidationDtoSchema)` to create a new message.
 */
export const NotNullValidationDtoSchema: GenMessage<NotNullValidationDto> = /*@__PURE__*/
  messageDesc(file_Messages_Validation, 12);

/**
 * Provides an enum value check validator.
 *
 * @generated from message time_tracking.messages.validation.IsInEnumValidationDto
 */
export type IsInEnumValidationDto = Message<"time_tracking.messages.validation.IsInEnumValidationDto"> & {
  /**
   * Optional message template. See for details:
   * https://docs.fluentvalidation.net/en/latest/built-in-validators.html#enum-validator
   *
   * @generated from field: google.protobuf.StringValue message_template = 1;
   */
  messageTemplate?: string | undefined;

  /**
   * Whether to disable this validator during development.
   *
   * @generated from field: bool disable_in_development = 2;
   */
  disableInDevelopment: boolean;

  /**
   * A custom string error code that will be returned as part of the validation error.
   *
   * @generated from field: google.protobuf.StringValue error_code = 3;
   */
  errorCode?: string | undefined;
};

/**
 * Describes the message time_tracking.messages.validation.IsInEnumValidationDto.
 * Use `create(IsInEnumValidationDtoSchema)` to create a new message.
 */
export const IsInEnumValidationDtoSchema: GenMessage<IsInEnumValidationDto> = /*@__PURE__*/
  messageDesc(file_Messages_Validation, 13);

/**
 * Provides a maximum count validator for collections.
 *
 * @generated from message time_tracking.messages.validation.MaximumCountValidationDto
 */
export type MaximumCountValidationDto = Message<"time_tracking.messages.validation.MaximumCountValidationDto"> & {
  /**
   * The configured maximum count.
   *
   * @generated from field: int32 value = 1;
   */
  value: number;

  /**
   * Optional message template. See for details:
   * https://docs.fluentvalidation.net/en/latest/built-in-validators.html#predicate-validator
   * The {MaxCount} is a custom message placeholder for the configured maximum count.
   *
   * @generated from field: google.protobuf.StringValue message_template = 2;
   */
  messageTemplate?: string | undefined;

  /**
   * Whether to disable this validator during development.
   *
   * @generated from field: bool disable_in_development = 3;
   */
  disableInDevelopment: boolean;

  /**
   * A custom string error code that will be returned as part of the validation error.
   *
   * @generated from field: google.protobuf.StringValue error_code = 4;
   */
  errorCode?: string | undefined;
};

/**
 * Describes the message time_tracking.messages.validation.MaximumCountValidationDto.
 * Use `create(MaximumCountValidationDtoSchema)` to create a new message.
 */
export const MaximumCountValidationDtoSchema: GenMessage<MaximumCountValidationDto> = /*@__PURE__*/
  messageDesc(file_Messages_Validation, 14);

/**
 * Provides a date-only validator for timestamps.
 *
 * @generated from message time_tracking.messages.validation.IsDateOnlyValidationDto
 */
export type IsDateOnlyValidationDto = Message<"time_tracking.messages.validation.IsDateOnlyValidationDto"> & {
  /**
   * Optional message template. See for details:
   * https://docs.fluentvalidation.net/en/latest/built-in-validators.html#predicate-validator
   *
   * @generated from field: google.protobuf.StringValue message_template = 1;
   */
  messageTemplate?: string | undefined;

  /**
   * Whether to disable this validator during development.
   *
   * @generated from field: bool disable_in_development = 2;
   */
  disableInDevelopment: boolean;

  /**
   * A custom string error code that will be returned as part of the validation error.
   *
   * @generated from field: google.protobuf.StringValue error_code = 3;
   */
  errorCode?: string | undefined;
};

/**
 * Describes the message time_tracking.messages.validation.IsDateOnlyValidationDto.
 * Use `create(IsDateOnlyValidationDtoSchema)` to create a new message.
 */
export const IsDateOnlyValidationDtoSchema: GenMessage<IsDateOnlyValidationDto> = /*@__PURE__*/
  messageDesc(file_Messages_Validation, 15);

/**
 * Provides a date and time validator that ensures no seconds part is present for timestamps.
 *
 * @generated from message time_tracking.messages.validation.IsDateAndTimeWithoutSecondsValidationDto
 */
export type IsDateAndTimeWithoutSecondsValidationDto = Message<"time_tracking.messages.validation.IsDateAndTimeWithoutSecondsValidationDto"> & {
  /**
   * Optional message template. See for details:
   * https://docs.fluentvalidation.net/en/latest/built-in-validators.html#predicate-validator
   *
   * @generated from field: google.protobuf.StringValue message_template = 1;
   */
  messageTemplate?: string | undefined;

  /**
   * Whether to disable this validator during development.
   *
   * @generated from field: bool disable_in_development = 2;
   */
  disableInDevelopment: boolean;

  /**
   * A custom string error code that will be returned as part of the validation error.
   *
   * @generated from field: google.protobuf.StringValue error_code = 3;
   */
  errorCode?: string | undefined;
};

/**
 * Describes the message time_tracking.messages.validation.IsDateAndTimeWithoutSecondsValidationDto.
 * Use `create(IsDateAndTimeWithoutSecondsValidationDtoSchema)` to create a new message.
 */
export const IsDateAndTimeWithoutSecondsValidationDtoSchema: GenMessage<IsDateAndTimeWithoutSecondsValidationDto> = /*@__PURE__*/
  messageDesc(file_Messages_Validation, 16);

/**
 * Provides a time validator that ensures no seconds part is present for durations.
 *
 * @generated from message time_tracking.messages.validation.IsTimeWithoutSecondsValidationDto
 */
export type IsTimeWithoutSecondsValidationDto = Message<"time_tracking.messages.validation.IsTimeWithoutSecondsValidationDto"> & {
  /**
   * Optional message template. See for details:
   * https://docs.fluentvalidation.net/en/latest/built-in-validators.html#predicate-validator
   *
   * @generated from field: google.protobuf.StringValue message_template = 1;
   */
  messageTemplate?: string | undefined;

  /**
   * Whether to disable this validator during development.
   *
   * @generated from field: bool disable_in_development = 2;
   */
  disableInDevelopment: boolean;

  /**
   * A custom string error code that will be returned as part of the validation error.
   *
   * @generated from field: google.protobuf.StringValue error_code = 3;
   */
  errorCode?: string | undefined;
};

/**
 * Describes the message time_tracking.messages.validation.IsTimeWithoutSecondsValidationDto.
 * Use `create(IsTimeWithoutSecondsValidationDtoSchema)` to create a new message.
 */
export const IsTimeWithoutSecondsValidationDtoSchema: GenMessage<IsTimeWithoutSecondsValidationDto> = /*@__PURE__*/
  messageDesc(file_Messages_Validation, 17);

/**
 * Provides a date and time validator that ensures a time stamp is after another referenced time stamp.
 *
 * @generated from message time_tracking.messages.validation.EnsureAfterValidationDto
 */
export type EnsureAfterValidationDto = Message<"time_tracking.messages.validation.EnsureAfterValidationDto"> & {
  /**
   * The field number of the field against which to validate.
   *
   * @generated from field: int32 field_number = 1;
   */
  fieldNumber: number;

  /**
   * Optional minimum required difference in seconds from the referenced time stamp.
   *
   * @generated from field: int32 minimum_difference_in_seconds = 2;
   */
  minimumDifferenceInSeconds: number;

  /**
   * Optional message template. See for details:
   * https://docs.fluentvalidation.net/en/latest/built-in-validators.html#predicate-validator
   * The {ReferencedPropertyName} is a custom message placeholder for the configured referenced field number name.
   *
   * @generated from field: google.protobuf.StringValue message_template = 3;
   */
  messageTemplate?: string | undefined;

  /**
   * Whether to disable this validator during development.
   *
   * @generated from field: bool disable_in_development = 4;
   */
  disableInDevelopment: boolean;

  /**
   * A custom string error code that will be returned as part of the validation error.
   *
   * @generated from field: google.protobuf.StringValue error_code = 5;
   */
  errorCode?: string | undefined;
};

/**
 * Describes the message time_tracking.messages.validation.EnsureAfterValidationDto.
 * Use `create(EnsureAfterValidationDtoSchema)` to create a new message.
 */
export const EnsureAfterValidationDtoSchema: GenMessage<EnsureAfterValidationDto> = /*@__PURE__*/
  messageDesc(file_Messages_Validation, 18);

/**
 * Provides an inclusive upper bound validator for durations.
 *
 * @generated from message time_tracking.messages.validation.DurationLessThanOrEqualToValidationDto
 */
export type DurationLessThanOrEqualToValidationDto = Message<"time_tracking.messages.validation.DurationLessThanOrEqualToValidationDto"> & {
  /**
   * The configured inclusive uppper bound.
   *
   * @generated from field: google.protobuf.Duration value = 1;
   */
  value?: Duration | undefined;

  /**
   * Optional message template. See for details:
   * https://docs.fluentvalidation.net/en/latest/built-in-validators.html#predicate-validator
   * The {ComparisonValue} is a custom message placeholder for the configured value above.
   *
   * @generated from field: google.protobuf.StringValue message_template = 2;
   */
  messageTemplate?: string | undefined;

  /**
   * Whether to disable this validator during development.
   *
   * @generated from field: bool disable_in_development = 3;
   */
  disableInDevelopment: boolean;

  /**
   * A custom string error code that will be returned as part of the validation error.
   *
   * @generated from field: google.protobuf.StringValue error_code = 4;
   */
  errorCode?: string | undefined;
};

/**
 * Describes the message time_tracking.messages.validation.DurationLessThanOrEqualToValidationDto.
 * Use `create(DurationLessThanOrEqualToValidationDtoSchema)` to create a new message.
 */
export const DurationLessThanOrEqualToValidationDtoSchema: GenMessage<DurationLessThanOrEqualToValidationDto> = /*@__PURE__*/
  messageDesc(file_Messages_Validation, 19);

/**
 * Provides an inclusive lower bound validator for durations.
 *
 * @generated from message time_tracking.messages.validation.DurationGreaterThanOrEqualToValidationDto
 */
export type DurationGreaterThanOrEqualToValidationDto = Message<"time_tracking.messages.validation.DurationGreaterThanOrEqualToValidationDto"> & {
  /**
   * The configured inclusive lower bound.
   *
   * @generated from field: google.protobuf.Duration value = 1;
   */
  value?: Duration | undefined;

  /**
   * Optional message template. See for details:
   * https://docs.fluentvalidation.net/en/latest/built-in-validators.html#predicate-validator
   * The {ComparisonValue} is a custom message placeholder for the configured value above.
   *
   * @generated from field: google.protobuf.StringValue message_template = 2;
   */
  messageTemplate?: string | undefined;

  /**
   * Whether to disable this validator during development.
   *
   * @generated from field: bool disable_in_development = 3;
   */
  disableInDevelopment: boolean;

  /**
   * A custom string error code that will be returned as part of the validation error.
   *
   * @generated from field: google.protobuf.StringValue error_code = 4;
   */
  errorCode?: string | undefined;
};

/**
 * Describes the message time_tracking.messages.validation.DurationGreaterThanOrEqualToValidationDto.
 * Use `create(DurationGreaterThanOrEqualToValidationDtoSchema)` to create a new message.
 */
export const DurationGreaterThanOrEqualToValidationDtoSchema: GenMessage<DurationGreaterThanOrEqualToValidationDto> = /*@__PURE__*/
  messageDesc(file_Messages_Validation, 20);

